import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex w-fit shrink-0 items-center justify-center gap-1 rounded-md border px-2 py-0.5 text-xs font-medium leading-4 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-3",
  {
    variants: {
      tone: {
        neutral:
          "border-[var(--color-border)] bg-[var(--color-surface)] text-[var(--color-foreground-muted)]",
        brand:
          "border-[color-mix(in_srgb,var(--color-accent)_34%,white)] bg-[var(--color-brand-soft)] text-[var(--color-brand)]",
        success:
          "border-[color-mix(in_srgb,var(--color-success)_30%,white)] bg-[color-mix(in_srgb,var(--color-success)_10%,white)] text-[var(--color-success)]",
        warning:
          "border-[color-mix(in_srgb,var(--color-warning-fill)_48%,white)] bg-[color-mix(in_srgb,var(--color-warning-fill)_16%,white)] text-[var(--color-warning)]",
        danger:
          "border-[color-mix(in_srgb,var(--color-danger-fill)_42%,white)] bg-[color-mix(in_srgb,var(--color-danger-fill)_13%,white)] text-[var(--color-danger)]",
      },
    },
    defaultVariants: {
      tone: "neutral",
    },
  },
);

export type BadgeProps = React.HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof badgeVariants>;

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} data-slot="badge" {...props} />;
}

export { badgeVariants };
